var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJourneyAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58253_27097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2876 5.62726V5.12726H45.7876H3.4126H2.9126V5.62726V32.2224V33.283L3.73076 32.6082L12.1782 25.64L21.1704 33.0576L21.5318 33.3557L21.8528 33.0144L33.5439 20.5818L45.4546 31.2174L46.2876 31.9612V30.8444V5.62726ZM3.09443 35.4826L2.9126 35.6326V35.8683V42.3727V42.8727H3.4126H12.3661H12.5823L12.7303 42.7152L19.922 35.0675L20.2875 34.6788L19.8759 34.3393L12.4963 28.2519L12.1781 27.9895L11.86 28.2519L3.09443 35.4826ZM15.8626 42.0302L15.0703 42.8728H16.2268H45.7876H46.2876V42.3728V34.615V34.3912L46.1206 34.2421L34.0178 23.4348L33.6543 23.1102L33.3205 23.4652L15.8626 42.0302ZM1.1001 44.6853V3.31476H48.1001V44.6853H1.1001Z",
    fill: "#264073",
    stroke: "#264073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6003 21.5775C28.2211 21.5775 31.1669 18.6318 31.1669 15.0109C31.1669 11.39 28.2211 8.44424 24.6003 8.44424C20.9794 8.44424 18.0337 11.3901 18.0337 15.0109C18.0337 18.6317 20.9794 21.5775 24.6003 21.5775ZM24.6003 11.2567C26.6703 11.2567 28.3544 12.9409 28.3544 15.0109C28.3544 17.0809 26.6703 18.765 24.6003 18.765C22.5303 18.765 20.8462 17.0809 20.8462 15.0109C20.8462 12.9409 22.5303 11.2567 24.6003 11.2567Z",
    fill: "#264073"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58253_27097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.600098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneyAvatar);
export default __webpack_public_path__ + "static/media/journey_avatar.49392cc39ca0c9322a1fc841e4e63487.svg";
export { ForwardRef as ReactComponent };